module.exports = __webpack_public_path__ + "img/syf.d7df6e1c.png";